import { Flex, HStack, Text, IconButton, Box } from "@chakra-ui/react";
import { Menu } from "lucide-react";
import { Logo } from "@/components/Logo";
import { UserMenu } from "@/components/UserMenu";
import { CompanyBrand } from "@/components/CompanyBrand";
import { NotificationBell } from "@/components/NotificationBell";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme/colors";

export const AppHeader = ({ onOpenMenu }) => {
  const { activeCompany, isSuperAdmin } = useAuth();
  // The acting company (or "All companies") always shows beside the logo, so
  // phones collapse the wordmark whenever that chip renders to avoid colliding
  // with the bell/avatar cluster.
  const branded = Boolean(activeCompany) || isSuperAdmin;
  return (
    <Flex
      as="header"
      data-testid="app-header"
      position="fixed"
      top="0"
      left="0"
      right="0"
      h="64px"
      zIndex={20}
      align="center"
      justify="space-between"
      px={{ base: "4", lg: "6" }}
      bg={colors.white}
      borderBottom="1px solid"
      borderColor={colors.border}
    >
      <HStack gap="3" minW="0" flex="1" overflow="hidden">
        <IconButton
          aria-label="Open menu"
          data-testid="open-menu-button"
          variant="ghost"
          size="sm"
          display={{ base: "inline-flex", lg: "none" }}
          onClick={onOpenMenu}
          color={colors.textPrimary}
          _hover={{ bg: colors.cream }}
        >
          <Menu size={22} />
        </IconButton>

        <HStack gap="2.5" data-testid="brand-lockup" flexShrink={0}>
          <Logo size={38} />
          <Text fontFamily="heading" fontWeight="700" fontSize={{ base: "lg", md: "xl" }} letterSpacing="-0.01em" lineHeight="1"
            display={branded ? { base: "none", sm: "block" } : "block"}>
            <Box as="span" color={colors.teal}>Hakina</Box>{" "}
            <Box as="span" color={colors.textPrimary}>Safety</Box>
          </Text>
        </HStack>

        <CompanyBrand />
      </HStack>

      <HStack gap="1.5" flexShrink={0}>
        <NotificationBell />
        <UserMenu />
      </HStack>
    </Flex>
  );
};
